import { doc, onSnapshot, runTransaction, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase/client";
import { LEGAL_VERSION, legalAcceptanceCurrent, legalDocument, type LegalLanguage } from "./legalPolicy";

export function watchLegalAcceptance(uid: string, publish: (accepted: boolean) => void, failed: () => void) {
  return onSnapshot(doc(db,"users",uid,"legal","acceptance"),{includeMetadataChanges:true},snapshot => {
    if (auth.currentUser?.uid !== uid || snapshot.metadata.hasPendingWrites) return;
    publish(snapshot.exists() && legalAcceptanceCurrent(snapshot.data(),uid));
  },failed);
}
export async function acceptLegalDocuments(uid: string, language: LegalLanguage) {
  if (auth.currentUser?.uid !== uid) throw new Error("LEGAL_ACCOUNT_CHANGED");
  const reference = doc(db,"users",uid,"legal","acceptance");
  await runTransaction(db,async transaction => {
    if (auth.currentUser?.uid !== uid) throw new Error("LEGAL_ACCOUNT_CHANGED");
    const snapshot = await transaction.get(reference);
    if (snapshot.exists() && legalAcceptanceCurrent(snapshot.data(),uid)) return;
    transaction.set(reference,{
      uid,language,termsVersion:LEGAL_VERSION,privacyVersion:LEGAL_VERSION,
      termsHash:legalDocument("terms",language).hash,privacyHash:legalDocument("privacy",language).hash,
      termsAccepted:true,privacyAcknowledged:true,termsRead:true,privacyRead:true,
      acceptedAt:serverTimestamp(),firstAcceptedAt:snapshot.data()?.firstAcceptedAt || serverTimestamp()
    });
  });
  // A resolved Firestore transaction means the server has acknowledged the write.
  // A second mandatory server read can fail transiently after a successful commit,
  // producing a false "acceptance not confirmed" banner while the gate opens.
  if (auth.currentUser?.uid !== uid) throw new Error("LEGAL_ACCOUNT_CHANGED");
}
